<div class="question_and_answer" tabindex="0" [attr.aria-label]="ariaLabel">
	<p class="fw500 question">{{ productQuestion.caption }}</p>
	<div class="flex align_items_flex_start gap_very_small overflow_hidden" *ngIf="productQuestion.answer" @verticalExpansionSlower_withDelay [@.disabled]="disableAnimation">
		<mat-icon class="material-icons-outlined color_black_inactive margin_left_small">question_answer</mat-icon>
		<div class="color_black_inactive">
			<span class="flex1 fw400 body1">
				{{ productQuestion.answer }}
			</span>
			&nbsp;&nbsp;-&nbsp;&nbsp;
			<span class="body2">
				{{ productQuestion.date_answer! | timeAgo }}
			</span>
		</div>
	</div>
</div>